/* ============================================================
   HIT: gaveta (menu "Loja" no celular; filtros e sacola entram nas tarefas seguintes).
   Portado de direcao-b/index.html: slide() e abreG() (linhas 1450-1472), sem Motion: a entrada e a saída são
   animações da Web Animations API (a mesma curva --ease da B; as durações vêm do CSS, --dur-abrir e --dur-fechar em hit-base.css,
   que também usa a de fechar no véu e no atraso do visibility: uma fonte só).

     window.HitGaveta = { abrir(nome, origem), fechar(), registrar(nome, montar), tem(nome) }

   Fica por cima do HitCamadas (hit-camadas.js): foco preso, Esc, véu, trava de rolagem e devolução do foco são dele.
   Aqui só entram o conteúdo, o deslize e a troca entre gavetas.

   - Há UMA gaveta no layout (#gaveta, dentro de #gav). abrir("menu") preenche título, corpo e rodapé (.g-pe) dela e a abre.
     Com ela já aberta, abrir("outra") só troca o conteúdo e repete a entrada (a B trocava o conteúdo no lugar).
   - Conteúdo de "nome": uma função registrada (registrar) ou, sem ela, o <template id="gav-nome"> da página, com o título em
     data-titulo (o do menu está em sections/header.liquid). A função devolve { titulo, corpo, pe }; corpo e pe são Node, DocumentFragment
     ou HTML do próprio tema (texto de fora nunca entra aqui sem escape).
   - Gatilho: qualquer [data-gaveta="nome"]. Se não há conteúdo para "nome" (a sacola, até a Tarefa 21), o clique segue o link normal.
   ============================================================ */
(function () {
  'use strict';

  if (window.HitGaveta) return;

  var DESK = window.matchMedia('(min-width:900px)');
  var REDUZIDO = window.matchMedia('(prefers-reduced-motion:reduce)');
  var CURVA = 'cubic-bezier(.16,.1,.3,1)'; // --ease da B

  var fontes = {};     // nome -> montar(): { titulo, corpo, pe }
  var aberta = null;   // nome da gaveta aberta; null fechada
  var gatilho = null;  // botão que abriu (ganha aria-expanded)
  var anim = null;     // animação em curso
  var ficha = 0;       // sobe a cada abrir/fechar; o fim de uma saída só limpa se ninguém abriu de novo

  function raiz() { return document.getElementById('gaveta'); }

  function ehNo(x) { return x && typeof x === 'object' && typeof x.nodeType === 'number'; }

  /* ---------- conteúdo ---------- */
  function doTemplate(nome) {
    var t = document.getElementById('gav-' + nome);
    if (!t || !t.content) return null;
    return { titulo: t.getAttribute('data-titulo') || '', corpo: t.content.cloneNode(true), pe: null };
  }

  function conteudo(nome) {
    var montar = fontes[nome];
    return montar ? montar() : doTemplate(nome);
  }

  function tem(nome) {
    return typeof fontes[nome] === 'function' || !!document.getElementById('gav-' + nome);
  }

  function colocar(alvo, valor) {
    alvo.replaceChildren();
    if (valor == null || valor === '') return;
    if (ehNo(valor)) alvo.appendChild(valor);
    else alvo.insertAdjacentHTML('beforeend', String(valor));
  }

  function preencher(g, c) {
    g.querySelector('#g-t').textContent = c.titulo || '';
    var corpo = g.querySelector('.g-corpo');
    colocar(corpo, c.corpo);
    corpo.scrollTop = 0;
    var pe = g.querySelector('.g-pe');
    colocar(pe, c.pe);
    pe.hidden = !pe.hasChildNodes();
  }

  /* ---------- deslize (slide da B) ---------- */
  // duração em ms de um token de tempo do CSS (--dur-abrir, --dur-fechar); sem o token, 0: o deslize fica instantâneo, nada quebra
  function duracaoCss(token) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    var n = parseFloat(v);
    if (!(n >= 0)) return 0;
    return /ms$/.test(v) ? n : n * 1000;
  }

  // celular: sobe de baixo; computador: entra pela direita. O +8 cobre a sombra.
  function fora(g) {
    return DESK.matches
      ? 'translate(' + (g.offsetWidth + 8) + 'px,0px)'
      : 'translate(0px,' + (g.offsetHeight + 8) + 'px)';
  }

  // começa de onde a gaveta está agora (virar no meio da animação não dá salto), ou de fora quando é a primeira entrada
  function deslizar(g, abrir, inicio) {
    var menu = g.getAttribute('data-gaveta-aberta') === 'menu';
    if (menu) {
      if (anim) anim.cancel();
      var reduzido = REDUZIDO.matches;
      anim = g.animate(reduzido ? [{ opacity: 1 }, { opacity: 1 }] : [
        { opacity: abrir ? 0 : 1, transform: abrir ? 'translateY(8px)' : 'translateY(0)' },
        { opacity: abrir ? 1 : 0, transform: abrir ? 'translateY(0)' : 'translateY(8px)' }
      ], { duration: reduzido ? 0 : (abrir ? 200 : 140), easing: CURVA, fill: abrir ? 'none' : 'forwards' });
      return anim;
    }
    var de;
    if (inicio) {
      de = fora(g);
    } else {
      var cs = getComputedStyle(g).transform;
      var m = new DOMMatrixReadOnly(cs === 'none' ? undefined : cs);
      de = 'translate(' + m.m41 + 'px,' + m.m42 + 'px)';
    }
    var para = abrir ? 'translate(0px,0px)' : fora(g);
    if (anim) anim.cancel();
    var duracao = REDUZIDO.matches ? 0 : duracaoCss(abrir ? '--dur-abrir' : '--dur-fechar');
    // na saída o estado final fica preso (a gaveta some por visibility, depois do atraso do CSS); na entrada a animação sai de cena
    anim = g.animate([{ transform: de }, { transform: para }], {
      duration: duracao, easing: CURVA, fill: abrir ? 'none' : 'forwards'
    });
    return anim;
  }

  /* ---------- gatilho ---------- */
  function marcarGatilho(el, aberto) {
    if (el && el.tagName === 'BUTTON') el.setAttribute('aria-expanded', aberto ? 'true' : 'false');
  }

  // o HitCamadas marca como expandido todo [aria-controls="gaveta"]; a gaveta é uma só para menu, filtros e sacola,
  // então só o gatilho que abriu agora fica expandido (o botão "Loja" não pode dizer "aberto" com a sacola na tela)
  function conferirGatilhos() {
    document.querySelectorAll('[aria-controls~="gaveta"]').forEach(function (b) {
      if (b !== gatilho) b.setAttribute('aria-expanded', 'false');
    });
  }

  /* ---------- API ---------- */
  function abrir(nome, origem) {
    var g = raiz();
    if (!g || !window.HitCamadas) return false;
    var c = conteudo(nome);
    if (!c) return false;
    ficha += 1;
    preencher(g, c);
    g.setAttribute('data-gaveta-aberta', nome);
    var fecharBotao = g.querySelector('.fechar');
    if (!fecharBotao.dataset.rotuloOriginal) fecharBotao.dataset.rotuloOriginal = fecharBotao.getAttribute('aria-label');
    fecharBotao.setAttribute('aria-label', nome === 'menu' ? 'Fechar menu' : fecharBotao.dataset.rotuloOriginal);

    if (gatilho && gatilho !== origem) marcarGatilho(gatilho, false);
    gatilho = origem || null;
    marcarGatilho(gatilho, true);

    if (aberta) {
      conferirGatilhos();
      // já aberta (outro nome): troca o conteúdo e repete a entrada; o foco vai para o começo do conteúdo novo
      aberta = nome;
      deslizar(g, true, false);
      var alvo = g.querySelector('[data-camada-foco], .fechar');
      if (alvo) alvo.focus({ preventScroll: true });
      return true;
    }
    aberta = nome;
    window.HitCamadas.abrir(g, origem);
    conferirGatilhos();
    deslizar(g, true, true);
    if (nome === 'menu' && origem && origem.hasAttribute('data-menu-buscar')) {
      var busca = g.querySelector('[data-busca-input]');
      if (busca) busca.focus({ preventScroll: true });
    }
    return true;
  }

  function fechar() {
    var g = raiz();
    if (!g || !aberta || !window.HitCamadas) return;
    window.HitCamadas.fechar(g);
  }

  function registrar(nome, montar) {
    if (typeof nome !== 'string' || !nome || typeof montar !== 'function') {
      throw new TypeError('HitGaveta.registrar(nome, montar): nome texto e montar função');
    }
    fontes[nome] = montar;
  }

  /* ---------- saída: vale para Esc, véu, botão × e para outra camada que abre por cima ---------- */
  function aoFechar() {
    var g = raiz();
    if (!g || !aberta) return;
    aberta = null;
    marcarGatilho(gatilho, false);
    gatilho = null;
    var minha = ++ficha;
    deslizar(g, false, false).finished.then(function () {
      if (minha !== ficha) return;
      g.removeAttribute('data-gaveta-aberta');
      g.querySelector('.g-corpo').replaceChildren();
    }, function () { /* animação trocada no meio: quem a trocou cuida do resto */ });
  }

  document.addEventListener('hit:camada-fechou', function (ev) {
    if (ev.target === raiz()) aoFechar();
  });

  /* ---------- cliques ---------- */
  document.addEventListener('click', function (ev) {
    if (ev.defaultPrevented) return;
    var alvo = ev.target;
    if (!alvo || !alvo.closest) return;

    if (alvo.closest('#gaveta .fechar')) { fechar(); return; }

    // Link para a própria página: fecha antes da navegação local.
    var link = aberta && alvo.closest('#gaveta a[href]');
    if (link) {
      var u = new URL(link.href, location.href);
      if (u.origin === location.origin && u.pathname === location.pathname && u.search === location.search) fechar();
      return;
    }

    var gat = alvo.closest('[data-gaveta]');
    if (!gat || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    var nome = gat.getAttribute('data-gaveta');
    if (!tem(nome)) return; // sem conteúdo ainda: o link segue o caminho normal (/cart, por exemplo)
    // só segura o link se a gaveta abriu: sem gaveta no HTML, sem HitCamadas ou sem conteúdo, o clique segue o caminho normal
    if (abrir(nome, gat)) ev.preventDefault();
  });

  // voltar de outra página pelo histórico com a página guardada (bfcache) devolvia a gaveta aberta e o fundo travado
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) fechar();
  });

  REDUZIDO.addEventListener('change', function () {
    if (REDUZIDO.matches && anim && raiz() && raiz().getAttribute('data-gaveta-aberta') === 'menu') anim.finish();
  });

  window.HitGaveta = Object.freeze({ abrir: abrir, fechar: fechar, registrar: registrar, tem: tem });
})();
